import dspAxiosCall from '@/pages/dsp/DspAxiosCall.ts'
import { UploadOutlined } from '@ant-design/icons'
import { Button, Form, Modal, Result, Spin, Upload } from 'antd'
import { AdUnitIdResultBean } from 'common/api/api'
import * as React from 'react'
import { useState } from 'react'

const stageList = [
  { id: 0, prev: 'Cancel', next: 'Save' },
  { id: 1, prev: 'Back', next: 'Ok' },
]

interface ZoneAdUnitIdsProps {
  visible: boolean
  toggle: () => void
  dspId: number
}

const AdUnitIds: React.FC<ZoneAdUnitIdsProps> = (props) => {
  const [fetching, setFetching] = useState(false)
  const [error, setError] = useState<any>(null)
  const [result, setResult] = useState<AdUnitIdResultBean>({})
  const [stage, setStage] = useState(stageList[0])
  const [csv, setCsv] = useState<File | null>(null)

  const handleStage = (e: React.MouseEvent<HTMLButtonElement>) => {
    const value = e.currentTarget.value
    switch (value) {
      case '-1':
        props.toggle()
        break
      case '0':
        setError(null)
        setStage(stageList[value])
        break
      case '1':
        setFetching(true)
        dspAxiosCall
          .updateZoneAdUnitIds(props.dspId, csv)
          .then((res: AdUnitIdResultBean) => {
            setFetching(false)
            setResult(res)
            setStage(stageList[value])
          })
          .catch((err: { error: string }) => {
            setFetching(false)
            setError(err.error)
            setStage(stageList[value])
          })
        break
      default:
        props.toggle()
        setError(null)
        setResult({})
        setStage(stageList[0])
    }
  }

  const renderFooter = () => [
    <Button key="k1" value={stage.id - 1} onClick={handleStage}>
      {stage.prev}
    </Button>,
    <Button disabled={fetching} key="k2" value={stage.id + 1} type="primary" onClick={handleStage}>
      {stage.next}
    </Button>,
  ]

  const renderStage0 = () => (
    <Form labelCol={{ span: 5 }} style={{ width: '100%' }}>
      <Form.Item label="CSV format">
        <span>Zone ID,Ad Unit ID</span>
      </Form.Item>
      <Form.Item required label="Ad Unit IDs">
        {props.visible && (
          <Upload
            name="data"
            beforeUpload={(file) => {
              setCsv(file)
              return false
            }}
            onRemove={() => setCsv(null)}
          >
            <Button>
              <UploadOutlined />
              Upload CSV
            </Button>
          </Upload>
        )}
      </Form.Item>
    </Form>
  )

  const renderStage1 = () =>
    error ? (
      <Result
        status="error"
        title={
          <div>
            <h4>Something bad happened</h4>
            <p style={{ fontSize: 16 }}>Reason: {error}</p>
          </div>
        }
      />
    ) : (
      <Result
        status="success"
        title={
          <div>
            <h4>Success</h4>
            <p style={{ fontSize: 16 }}>
              Result: {result.updated} / {result.total}
            </p>
            {Object.values(result.errorMap || {}).length !== 0 && (
              <p style={{ fontSize: 16 }}>
                Error map:
                <pre
                  style={{
                    marginTop: 8,
                    maxWidth: 640,
                    maxHeight: 120,
                    textAlign: 'left',
                    overflow: 'scroll',
                  }}
                >
                  {JSON.stringify(result.errorMap, null, 4)}
                </pre>
              </p>
            )}
          </div>
        }
      />
    )

  const renderModal = () => (
    <Modal
      title="Ad Unit IDs"
      footer={renderFooter()}
      width={720}
      visible={props.visible}
      onCancel={() => {
        props.toggle()
        setCsv(null)
        setError(null)
        setResult({})
        setStage(stageList[0])
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 360 }}>
        {fetching ? <Spin size="large" /> : null}
        {stage.id == 0 && !fetching ? renderStage0() : null}
        {stage.id == 1 && !fetching ? renderStage1() : null}
      </div>
    </Modal>
  )

  return renderModal()
}

export default AdUnitIds
